import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { ProjectGate } from '@/features/projects/ProjectGate';
import { ProjectWorkspaceHeader } from '@/features/projects/ProjectWorkspaceHeader';
import { useProjectContext } from '@/project/ProjectContext';
import campStyles from './Campaigns.module.css';

const TABS = [
  { to: '/app/campagnes', label: 'Portfolio', end: true },
  { to: '/app/campagnes/nieuw', label: 'Nieuwe campagne', end: true },
  { to: '/app/campagnes/bibliotheek', label: 'Bibliotheek', end: true },
] as const;

function sectionLead(pathname: string): string {
  if (pathname.includes('/nieuw')) {
    return 'Begeleide setup: doelgroep, sequence, preview en aanmaken — daarna starten in het command center.';
  }
  if (pathname.includes('/bibliotheek')) {
    return 'Lijsten, sequences, templates en suppressies — de bouwstenen voor outreach en broadcast.';
  }
  if (/^\/app\/campagnes\/[^/]+$/.test(pathname)) {
    return 'Live KPI’s, enrollment, verzendinstellingen en logs voor één campagne.';
  }
  return 'Overzicht van campagnes per project, readiness en snelle acties.';
}

export function CampaignsShell() {
  const { pathname } = useLocation();
  const { selectedProject, setSelectedProjectId } = useProjectContext();
  const onDetail = /^\/app\/campagnes\/[^/]+$/.test(pathname);
  const bibliotheek = pathname.includes('/bibliotheek');

  return (
    <ProjectGate requireSelection pageTitle="Campagnes">
      <div
        className={[
          campStyles.page,
          bibliotheek ? campStyles.pageFullscreen : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {!onDetail ? (
          <>
            <ProjectWorkspaceHeader
              title="Campagnes"
              subtitle={sectionLead(pathname)}
              projectName={selectedProject?.name ?? '—'}
              onSwitchProject={() => setSelectedProjectId(null)}
            />
            <nav className={campStyles.mainNav} aria-label="Campagnes secties">
              {TABS.map((t) => (
                <NavLink
                  key={t.to}
                  to={t.to}
                  end={t.end}
                  className={({ isActive }) =>
                    [campStyles.mainNavLink, isActive ? campStyles.mainNavLinkActive : ''].join(' ')
                  }
                >
                  {t.label}
                </NavLink>
              ))}
            </nav>
          </>
        ) : null}
        <Outlet />
      </div>
    </ProjectGate>
  );
}
